import type { Rect } from './bubble-physics';

// Reads every `[data-bubble-anchor]` element in the document and
// returns its rect translated into the container's coordinate space.
// Lives in its own module so both the per-frame physics loop and the
// initial spawn (which needs to reject overlapping positions) can call
// it without circular imports.

export function readBubbleAnchors(container: HTMLElement): Rect[] {
  const cr = container.getBoundingClientRect();
  const els = globalThis.document.querySelectorAll<HTMLElement>(
    '[data-bubble-anchor]'
  );
  const rects: Rect[] = [];
  els.forEach((el) => {
    const r = el.getBoundingClientRect();
    rects.push({
      x: r.left - cr.left,
      y: r.top - cr.top,
      w: r.width,
      h: r.height,
    });
  });
  return rects;
}

type BubbleBox = { x: number; y: number; size: number };

export function rectsOverlap(box: BubbleBox, rects: Rect[]): boolean {
  for (let i = 0; i < rects.length; i++) {
    const r = rects[i];
    if (!r) continue;
    if (
      box.x + box.size > r.x &&
      box.x < r.x + r.w &&
      box.y + box.size > r.y &&
      box.y < r.y + r.h
    )
      return true;
  }
  return false;
}
